// test556
(556 && 0);
